import { RwfBackend, IRwfSettings, DefaultCompanyAccess, SetCurrentCompany } from '@common/rwf';
import { CompatibilityService } from '@common/services/compatibilityservice';
import { NavPageAdminService } from '@common/navdata/navpageadminservice';
import { IDialogService } from '@common/services/dialogservice';
import { IInfOperation, fn, INamed } from '@common/utils';
import { INavCustomizationInfo } from '@common/nav';
import { INavUrlInfoEx, INavUrlInfo, ResolveNavUrl, BuildNavUrl } from '@common/navdata';
import { CtrlCustomMenuItems, IPersistedCustomMenuItem } from './custommenu/custommenu.ctrl';

//#region routeChangeCompany

// Singnle Menu Item for ChangeCompany
interface ChangeCompanyItem extends IInfOperation {
    Name: string;
    Hint?: string;
    Items?: any; // any[], () => any[]
    Current?: boolean;
};

export class CtrlChangeCompany {
    static $inject = ["$scope", "RwfBackend", "CompatibilityService", "NavPageAdminService", "DialogService"];
    constructor(
        $scope: ng.IScope,
        rwfBackend: RwfBackend,
        $c: CompatibilityService,
        Admin: NavPageAdminService, DialogService: IDialogService) {

        const NavClient = $c.resolve("NavClient");
        const $rwf = $c.resolve("Rwf")("RwfBootstrap");
        const GetGlobalSettings = $rwf.Resolve.then(rwf => rwf.RwfSettings);
        var info = $scope["Info"] = {
            Progress: false,
            Configs: <INavCustomizationInfo[]>undefined,
            EnsureConfigInfo: EnsureConfigInfo,
            EnsureCompanies: () => GetGlobalSettings.then(s => EnsureCompanies(s.NavUrlInfo)),
            EnsureConfigStructure: EnsureConfigStructure,
            EnsureCustomItems : EnsureCustomItems
        };

        // TODO : Refactor Hierarchy Build ....
        type IChangeCompanyAction = ChangeCompanyItem | ChangeCompanyItem[];

        var configuredUrls: INamed<INavUrlInfoEx>;
        function EnsureConfigStructure(config?: { Name: string, Description: string, Urls: INavUrlInfoEx[] }): IChangeCompanyAction | PromiseLike<IChangeCompanyAction> {
            return GetGlobalSettings.then(settings => {
                if (!config) {
                    return NavClient.GetConfigStructure().then(configs => {
                        let allExplicitUrls = fn.FlattenArray(configs.map(item => item.Urls)),
                            allBaseUrls = fn.distinct(allExplicitUrls.map(item => item.BaseUrl)),
                            multipleBaseUrls = allBaseUrls.length > 1;

                        configuredUrls = fn.ToDictionary(allExplicitUrls, item => item.FullUrl);
                        if (configs.length == 1) {
                            var config = configs[0];
                            // Compatibility Single Item with given Mandanrt
                            if (config.Urls.length == 1 && config.Urls[0].Mandant) {
                                config = fn.clone(config);
                                configuredUrls = {};
                                delete config.Urls[0].Mandant;
                            }
                            return EnsureConfigStructure(config);
                        } else if (multipleBaseUrls) { // only try to Build ConfigStructure with Multiple dataBases ....
                            return configs.map(subConfig => {
                                var single = subConfig.Urls.length == 1 && subConfig.Urls[0];
                                if (single && single.Mandant) {
                                    return GetChangeContextAction(single, settings && settings.NavUrlInfo, single.Name);
                                } else {
                                    return {
                                        Name: subConfig.Description || subConfig.Name,
                                        Execute: fn.noop,
                                        Items: () => EnsureConfigStructure(subConfig)
                                    };
                                }
                            });
                        } else {
                            let singleUrl = fn.clone(configs[0].Urls[0]);
                            delete singleUrl.Mandant;
                            configuredUrls = {};
                            return EnsureConfigStructure({ Name: '', Description: '', Urls: [singleUrl] });
                        }
                    });
                };

                if (config.Urls.length == 1) {
                    if (config.Urls[0].Mandant)
                        return [GetChangeContextAction(config.Urls[0], settings && settings.NavUrlInfo, config.Urls[0].Name)];
                    else {
                        return EnsureCompanies(config.Urls[0]);
                    }
                }

                return config.Urls.map(url => {
                    if (url.Mandant)
                        var result = GetChangeContextAction(url, settings && settings.NavUrlInfo, url.Name);
                    else {
                        result = <ChangeCompanyItem>{
                            Current: false,
                            Enabled: true,
                            Name: (!url.Mandant && url.Name) || config.Description || config.Name || url.Name || url.Mandant || url.BaseUrl,
                            Execute: () => {
                                if (url.Mandant) {
                                    ChangeNavContext(url, settings);
                                }
                            },
                            Items: () => EnsureCompanies(url)
                        };
                    }
                    return result;
                });
            });
        }

        function EnsureConfigInfo() {
            if (info.Configs)
                return $c.when(info.Configs);
            info.Configs = [];
            return GetGlobalSettings.then(settings => {
                if (settings.User && settings.User.IsAdmin) {
                    return Admin.GetCustomizationInfos().then(infos => {
                        info.Configs = infos;
                        info.Configs.filter(item => item.Name == settings.ConfigName).forEach(item => item["Current"] = true);
                        return info.Configs;
                    });
                } else {
                    return $c.when(info.Configs);
                }
            });
        }

        function EnsureCompanies(navUrlInfo: INavUrlInfo) {
            return GetGlobalSettings.then(settings => {
                return rwfBackend.LoadCompanyInfo(navUrlInfo.FullUrl).then(companies => {
                    return companies.map(item => {
                        var companyInfo = ResolveNavUrl(BuildNavUrl(navUrlInfo.FullUrl, item));
                        //  Ensure explicitly configured Urls occur once in Menu- Structure
                        if (!configuredUrls || !configuredUrls[companyInfo.FullUrl])
                            return GetChangeContextAction(companyInfo, settings && settings.NavUrlInfo);
                    }).filter(fn.isSet);
                });
            });
        }

        var changeContextAction: INamed<ChangeCompanyItem> = {};
        function GetChangeContextAction(companyInfo: INavUrlInfo, settingsUrl: INavUrlInfo, name?: string) {
            var title = name || companyInfo.Mandant || "???",
                id = "" + companyInfo.FullUrl + "#" + title;
            var result = changeContextAction[id];

            if (result)
                return result;
            result = changeContextAction[id] = {
                Name: title,
                //Hidden : "Enabled",
                Current: settingsUrl && companyInfo.FullUrl.toLowerCase() == settingsUrl.FullUrl.toLowerCase(),
                Enabled: true,
                Execute: () => GetGlobalSettings.then(settings => ChangeNavContext(companyInfo, settings)),
                Hint: <string>undefined,
                Items: undefined
            };
            if (result.Current) {
                result.Hint = "";
            } else {
                rwfBackend.BootstrapRwf(companyInfo).then(() => {
                    result.Hint = "";
                }, err => {
                    if (result.Hint = fn.resolveToError(err)) {
                        result.Enabled = false;
                    }
                });
            }
            return result;
        }

        /** action to Change Company */
        function ChangeNavContext(navUrlInfo: INavUrlInfo, lSettings: IRwfSettings) {
            var companyName = navUrlInfo && navUrlInfo.Mandant,
                lInfo = lSettings && lSettings.NavUrlInfo;

            if (info.Progress || !companyName)
                return;

            var isCurrent = lInfo && (lInfo.FullUrl == navUrlInfo.FullUrl);

            if (isCurrent && DefaultCompanyAccess.get(navUrlInfo) !== navUrlInfo.Mandant)
                return;

            if (isCurrent)
                var userAction = DialogService.ShowConfirm({
                    message: 'Möchten Sie die Auswahl des Mandanten <strong>' + $("<div/>").text(lSettings && lSettings.CurrentCompany).html() +
                        '</strong> als Standard aufheben?',
                    messageIsHtml: true
                }).then(doIt => {
                    if (doIt) {
                        DefaultCompanyAccess.set(navUrlInfo, "");
                    }
                });
            else
                userAction = DialogService.ShowConfirm({
                    title: "Mandant wechseln?",
                    message: 'Möchten Sie den Mandanten wirklich von <strong>' + $("<div/>").text(lInfo.Mandant).html() +
                        '</strong> nach <strong>' + $("<div/>").text(companyName).html() + '</strong> wechseln?',
                    messageIsHtml: true
                }).then(changeMandant => {
                    if (changeMandant) {
                        const checkInfo = BuildNavUrl(navUrlInfo, companyName);
                        return SetCurrentCompany($c, checkInfo).then(() =>
                            // timeout : enforce window.location reflects changed url
                            $c.timeout().then(() => window.location.reload())
                        ).then(undefined, err => {
                            return DialogService.ShowError(fn.resolveToError(err, false));
                        });
                    }
                });

            $c.finally(userAction, () => { info.Progress = false; });
            info.Progress = true;
        };

        let mnuItems: CtrlCustomMenuItems;
        let pItems: PromiseLike<IPersistedCustomMenuItem[]>;
        function EnsureCustomItems() {
            return pItems || (pItems = (mnuItems || (mnuItems = new CtrlCustomMenuItems($c))).GetCurrentItems().then(items => {
                info["CustomItems"] = items || [];
                var root = info["RootCustomItem"] = items && items[0];
                return root?.Items;
            }));
        }
    }
}
